import { useEffect, useState } from 'react';

/**
 * Hook para aplicar debounce em valores
 * @param value - Valor a ser aplicado debounce
 * @param delay - Delay em milissegundos (padrão: 300ms)
 * @returns Valor com debounce aplicado
 */
export function useDebounce<T>(value: T, delay: number = 300): T {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);

    return debouncedValue;
}

